import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class ZRPOtherBucketsVisibilityInViewportApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.Search_ZRP_other_buckets;

  constructor(private action: GATrackingEventType) {}

  getPayload(): any {
    return {
      action: this.action,
      element: '',
    };
  }
}
